(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('GpmSeriesOpen', GpmSeriesOpen);

    GpmSeriesOpen.$inject = ['$resource', 'DateUtils'];

    function GpmSeriesOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/timeseries-data/gpm';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
